module.exports = __webpack_public_path__ + "assets/img/ja-b1400fb2.png";